import { Button, BUTTON_TYPES, Flex, IconCheckmarkCircle, mediaMixin, Paragraph, spaceMixin, token } from '@zillow/constellation';
import React from 'react';
import styled, { css } from 'styled-components';
import { getCopy } from '../utils/copyUtils';
export var SuccessMessageWrapper = styled(Flex).withConfig({
  displayName: "SuccessContent__SuccessMessageWrapper",
  componentId: "sc-1vedfur-0"
})(["margin:0px auto;max-width:470px;"]);
var StyledIconCheckmarkCircle = styled(IconCheckmarkCircle).withConfig({
  displayName: "SuccessContent__StyledIconCheckmarkCircle",
  componentId: "sc-1vedfur-1"
})(["&&{color:", ";width:77px;height:77px;margin-bottom:", ";}"], token('colors.green400'), spaceMixin('xs'));
var StyledButton = styled(Button).withConfig({
  displayName: "SuccessContent__StyledButton",
  componentId: "sc-1vedfur-2"
})(["width:100%;margin-top:", ";", ""], spaceMixin('md'), mediaMixin('md', css(["max-width:350px;"])));
var StyledConfirmationNote = styled(Paragraph).withConfig({
  displayName: "SuccessContent__StyledConfirmationNote",
  componentId: "sc-1vedfur-3"
})(["max-width:500px;", ""], mediaMixin('md', css(["text-align:center;"])));

var SuccessContent = function SuccessContent(_ref) {
  var onClose = _ref.onClose,
      shouldShowPrimaryCloseButton = _ref.shouldShowPrimaryCloseButton,
      contactFormVersion = _ref.contactFormVersion;
  return /*#__PURE__*/React.createElement(SuccessMessageWrapper, {
    "data-testid": "om-contact-agent-success",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(StyledIconCheckmarkCircle, null), /*#__PURE__*/React.createElement(Paragraph, {
    fontType: "h6"
  }, getCopy(contactFormVersion, 'successTitle')), /*#__PURE__*/React.createElement(StyledConfirmationNote, {
    marginTop: "sm"
  }, getCopy(contactFormVersion, 'successBody')), shouldShowPrimaryCloseButton && /*#__PURE__*/React.createElement(StyledButton, {
    "data-testid": "contact-agent-primary-close",
    buttonType: BUTTON_TYPES.primary,
    onClick: onClose
  }, "Close"));
};

export default SuccessContent;
//# sourceMappingURL=SuccessContent.js.map